/**
 * @description 全局Model tagModel 挂载到 redux 上
 */
import createModel, { Tction } from '@tkit/model';
import { APIS } from '@src/services';
import { ParamssearchPageTabUsingGet } from '@src/services/api/SearchApi';
import { ParamstagsUsingPost } from '@src/services/api/TagApi';
import * as models from '@services/model/models';

export interface State {
  tagListModel: models.SearchItemCondition[];
}

export const tagModelState: State = {
  tagListModel: []
};

const model = createModel({
  state: tagModelState,
  namespace: 'tagModel',
  reducers: {
    // 搜索标签
    setTagList: (state, action: Tction<{ tagListModel: models.SearchItemCondition[] }>) => {
      return {
        ...state,
        tagListModel: action.payload.tagListModel
      };
    },
    // 更新标签
    updateTagList: (state, action: Tction<{ tagListModel: models.SearchItemCondition }>) => {
      state.tagListModel.push(action.payload.tagListModel);
      return {
        ...state
      };
    }
  },
  effects: {
    // 搜索标签
    *getList(
      { namespace, put, tPut, tCall },
      action: Tction<{ params: ParamssearchPageTabUsingGet }>
    ): Iterator<{}, any, any> {
      const { params } = action.payload;
      const res = yield tCall(APIS.SearchApi.searchPageTabUsingGet, params);
      const { code, result } = res;
      if (code === 0) {
        yield tPut(model.actions.setTagList, {
          tagListModel: result
        });
      }
    },
    // 添加标签
    *addTag(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamstagsUsingPost;
        callBack: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const res = yield tCall(APIS.TagApi.tagsUsingPost, action.payload.params);
      const { code, result } = res;
      if (code === 0) {
        const { tagName } = action.payload.params;
        yield tPut(model.actions.updateTagList, {
          tagListModel: { id: result, name: tagName, typeName: 'TAG' }
        });
      }
      action.payload.callBack(res);
    }
  }
});

export default model;
